import {
  FIRST_INSTALL_ONBOARDING_PRODUCT_LABELS,
  FIRST_INSTALL_ONBOARDING_PRODUCTS,
  type FirstInstallOnboardingProduct,
} from "@redotech/account-common/onboarding";
import { unifiedOnboardingProductPath } from "../unified-onboarding/chargebacks-entry";

export function toFirstInstallOnboardingProduct(
  value: string | null | undefined,
): FirstInstallOnboardingProduct | null {
  if (!value) {
    return null;
  }
  for (const product of FIRST_INSTALL_ONBOARDING_PRODUCTS) {
    if (product === value) {
      return product;
    }
  }
  return null;
}

export function getFirstInstallProductLabel(
  product: FirstInstallOnboardingProduct | null,
): string | null {
  return product ? FIRST_INSTALL_ONBOARDING_PRODUCT_LABELS[product] : null;
}

// The role step collects jobProfile.job/level, which signup already requires;
// Shopify installs never answer, so only ask when either half is missing.
export function isRoleStepRequired(
  jobProfile:
    | { job?: readonly string[] | null; level?: string | null }
    | null
    | undefined,
): boolean {
  return !((jobProfile?.job?.length ?? 0) > 0 && jobProfile?.level != null);
}

export function getWelcomeCompletionOverridePath(args: {
  effectiveProduct: FirstInstallOnboardingProduct | null;
  teamId: string;
}): string | null {
  if (args.effectiveProduct === "chargebacks") {
    return unifiedOnboardingProductPath({
      teamId: args.teamId,
      productId: "chargeback_recovery",
    });
  }
  if (args.effectiveProduct === "order-editing") {
    return `/stores/${args.teamId}/welcome/order-editing`;
  }
  return null;
}

export function getWelcomeTermsCopy(args: {
  productLabel: string | null;
  teamName: string | null;
  partnerName: string | null;
}): { title: string; subtitle: string } {
  const productPart = args.productLabel ? ` ${args.productLabel}` : "";
  const title = args.teamName
    ? `Welcome to Redo${productPart}, ${args.teamName}!`
    : `Welcome to Redo${productPart}`;
  const subtitle = args.partnerName
    ? `Glad you joined us from ${args.partnerName}. First, accept our terms and conditions to continue.`
    : "Review and accept Redo's terms and conditions to get started.";
  return { title, subtitle };
}
